module.exports = __webpack_public_path__ + "img/research-office-trends-group.85290e8b.png";